import React from 'react';
import { Button } from '../components/ui/button';
import {
  FileText,
  Question,
  Lightbulb,
  BookmarkSimple,
} from '@phosphor-icons/react';

/**
 * Quick action buttons for Copilot panel
 */
export const CopilotQuickActions = ({ onAction, disabled }) => {
  const actions = [
    {
      id: 'summarize',
      label: 'Summarize Page',
      icon: FileText,
      prompt: 'Summarize the current page context and highlight key information.',
    },
    {
      id: 'explain',
      label: 'Explain Decision',
      icon: Question,
      prompt: 'Explain the decisions and logic shown on this page, including fairness and compliance considerations.',
    },
    {
      id: 'suggest',
      label: 'Suggest Improvement',
      icon: Lightbulb,
      prompt: 'Suggest ways to improve this workflow or process based on best practices.',
    },
    {
      id: 'propose',
      label: 'Propose Learning',
      icon: BookmarkSimple,
      prompt: 'I would like to propose a learning or configuration change.',
    },
  ];

  return (
    <div className="flex flex-wrap gap-2 p-3 border-b border-slate-200 bg-slate-50">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Button
            key={action.id}
            variant="outline"
            size="sm"
            onClick={() => onAction(action.prompt, action.id)}
            disabled={disabled}
            className="text-xs gap-1.5 h-8"
            data-testid={`copilot-action-${action.id}`}
          >
            <Icon size={14} weight="duotone" />
            {action.label}
          </Button>
        );
      })}
    </div>
  );
};

export default CopilotQuickActions;
